import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { recommendationAttributionRecordClick } from './recommendationAttribution'
import { recommendationAttributionFromRecommendedProduct } from './recommendationAttributionRecommendedProduct'

type RecommendationAttributionDirectAddToCartProduct = Pick<
  GkAirRecommendedProductDataWeb,
  'brand' | 'offer_id' | 'seller_id' | 'UID'
>

type RecommendationAttributionDirectAddToCartClickParams = {
  areaId?: string
  offerId?: string
  product?: RecommendationAttributionDirectAddToCartProduct
  serviceId?: string
}

/**
 * Records an add-to-cart interaction performed directly inside a recommendation widget.
 */
export const recommendationAttributionRecordDirectAddToCartClick = ({
  areaId,
  offerId,
  product,
  serviceId,
}: RecommendationAttributionDirectAddToCartClickParams): void => {
  const attribution = recommendationAttributionFromRecommendedProduct(product)

  if (!areaId || !attribution || !serviceId) {
    return
  }

  recommendationAttributionRecordClick({
    areaId,
    ...attribution,
    interactionType: 'add-to-cart',
    offerId,
    serviceId,
  })
}

/**
 * Records one direct add-to-cart interaction per product in a buy-together recommendation.
 */
export const recommendationAttributionRecordDirectAddToCartClicks = ({
  areaId,
  products,
  serviceId,
}: {
  areaId?: string
  products: RecommendationAttributionDirectAddToCartProduct[]
  serviceId?: string
}): void => {
  for (const product of products) {
    recommendationAttributionRecordDirectAddToCartClick({
      areaId,
      offerId: product.offer_id,
      product,
      serviceId,
    })
  }
}
